<template>
  <page-view class="data-board tms-style">
    <div slot="pageRight">
      <div class="data-statistics">
        <div class="title" style="display: flex;padding-bottom: 16px;">
          <span style="color:#59b9d3">{{ $t('RailwayFreight.Railway.DataStatistics') }}</span>
          <div style="width:2px;margin: 3px 8px;background-color: #9C9C9C;"></div>
          <span style="color:#9C9C9C;cursor:pointer" @click="goOrderSearch"> {{ $t('RailwayFreight.Railway.OrderInquiry') }}</span>
        </div>
        <div class="sieved">
          <div style="padding:0px 4px;background:#F6F6F8;height:40px">
            <a-radio-group
              class="time-select"
              v-model="timeStage"
              @change="timeStageChange"
            >
              <a-radio-button value="Month">{{ $t('RailwayFreight.Railway.CurrentMonth') }}</a-radio-button>
              <a-radio-button value="Season">{{ $t('RailwayFreight.Railway.CurrentQuarter') }}</a-radio-button>
              <a-radio-button value="Year">{{ $t('RailwayFreight.Railway.CurrentYear') }}</a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <div class="line"></div>
        <div
          class="data-item"
          v-loading="fullscreenLoading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(196,196,204, 0.8)"
        >
          <div class="data-item-left">
            <div class="accumulated" style="background: #ebfdee">
              <div>
                <p class="accumulated-label">{{ $t('RailwayFreight.Railway.Teu') }}</p>
                <div class="accumulated-content">
                  {{ currentSummary.teuCount }}
                </div>
              </div>
              <img src="@/assets/tms/accumulated_train_number.png" />
            </div>
            <div class="accumulated" style="background: #ffefef">
              <div>
                <p class="accumulated-label">{{ $t('RailwayFreight.Railway.ContainerVolume') }}</p>
                <div class="accumulated-content">
                  {{ currentSummary.cntrCount }}
                </div>
              </div>
              <img src="@/assets/tms/accumulated_train_number.png" />
            </div>
            <div class="teu-chart">
              <div class="teu-statistics">
                <div class="title"> {{ $t('RailwayFreight.Railway.' + timeTileRefer[timeStage]) }}</div>
                <div class="teu-date">
                  <div class="teu-desc">
                    <div>{{ $t('RailwayFreight.Railway.Teu') }}</div>
                  </div>
                </div>
                <BarChart id="teuChart" ref="teuChart" />
              </div>
            </div>
            <!--
            <div class="mileage-train-number">
              <div class="mileage-statistics">
                <div class="title">当季度统计</div>
                <div class="mileage-statistics-date">
                  <div class="mileage-statistics-desc">
                    <div>标箱数(TEU)</div>
                  </div>
                </div>
                <BarChart id="seasonChart" ref="seasonChart" />
              </div>
            </div>
            <div class="mileage-train-number">
              <div class="mileage-statistics">
                <div class="title">当月度统计(按线路)</div>
                <div class="mileage-statistics-date">
                  <div class="mileage-statistics-desc">
                    <div>标箱数(TEU)</div>
                  </div>
                </div>
                <BarChart id="monthChart" ref="monthChart" />
              </div>
            </div>
            -->
          </div>
        </div>
      </div>
      <div class="foot-tip">
        <i class="el-icon-warning-outline"></i>
        {{ $t('RailwayFreight.Railway.Declaration') }}
      </div>
    </div>
  </page-view>
</template>
<script>
import { PageView } from '@/components'
import BarChart from '@/components/barChart'
import LineChart from '@/components/lineChart'
import {
  getSummaryInfo,
  getOrderList
} from '@/api/rms'
import i18n from '@/i18n/i18n'
import moment from 'moment'
export default {
  components: {
    PageView,
    BarChart,
    LineChart
  },
  data() {
    return {
      moment,
      lang: 'zh',
      firstType: '',
      timeStage: 'Month',
      timeTileRefer: {
        Month: 'MonthlyStatistics',
        Season: 'QuarterlyStatistics',
        Year: 'YearlyStatistics'
      },
      summaryInfo: {},
      currentSummary: {},
      fullscreenLoading: false,
      basicData: {},
      circuitSelect: 'all',
      mileagePickerTime: moment(new Date()).format('YYYY-MM'),
      trainPickerTime: moment(new Date()).format('YYYY-MM'),
      yearPickerTime: moment(new Date()).format('YYYY'),
      routeList: [{ RouteName: 'all', label: '全部' }]
    }
  },
  created() {
    this.firstType = this.$route.meta.firstType;
    this.lang = this.$ls.get('lang');
    console.log(this.zh)
  },
  updated() {
    this.firstType = this.$route.meta.firstType;
  },
  mounted() {
    this.getDashboardData()
  },
  watch: {
    '$route'(val, from) {
      this.firstType = this.$route.meta.firstType;
      this.getDashboardData();
    }
  },
  methods: {
    timeStageChange() {
      this.getDashboardData();
    },
    getDashboardData() {
      this.fullscreenLoading = true
      getSummaryInfo({ firstType: this.firstType }).then(resp => {
        this.summaryInfo = resp.data;
        if ( this.timeStage === 'Month') {
          this.currentSummary = this.summaryInfo.monthSummary;
          this.$refs.teuChart.chartInit(this.summaryInfo.monthItems.map(item => item.name), this.summaryInfo.monthItems.map(item => item.value));
        } else if (this.timeStage === 'Season') {
          this.currentSummary = this.summaryInfo.seasonSummary;
          this.$refs.teuChart.chartInit(this.summaryInfo.seasonItems.map(item => item.name), this.summaryInfo.seasonItems.map(item => item.value));
        } else if ( this.timeStage === 'Year') {
          this.currentSummary = this.summaryInfo.yearSummary;
          this.$refs.teuChart.chartInit(this.summaryInfo.yearItems.map(item => item.name), this.summaryInfo.yearItems.map(item => item.value));
        } else {
          console.log('不支持的类型');
          this.currentSummary = {};
        }
        this.fullscreenLoading = false;
      });
    },
    goOrderSearch() {
      this.$router.push({
        name: 'railway' + this.firstType + 'OrderQuery'
      })
    }
  }
}
</script>
<style lang="less">
.data-board {
  padding: 10px;
  background: #f0f6fb;
  .plr25 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .ptb25 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }

  .data-statistics {
    background: white;
    padding: 16px 20px;
    border-radius: 4px;
    .sieved {
      display: flex;
      justify-content: space-between;
      margin-top: 14px;
      .time-select {
        margin: 4px 0;
      }
      .circuit {
        margin-top:8px;
        display: flex;
        align-items: center;
      }
    }
    .line {
      margin: 20px 0;
      border: 0.5px solid #e9ecf2;
    }
    .data-item {
      display: flex;
      .data-item-left {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(1, 100%);
        gap: 20px;
        .accumulated {
          display: flex;
          justify-content: space-between;
          padding: 16px 24px;
          height: 88px;
          .accumulated-label {
            font-size: 12px;
            font-weight: 400;
            color: #4b5563;
          }
          .accumulated-content {
            font-size: 26px;
            font-weight: 600;
            color: #111827;
            margin-top: 12px;
            margin-bottom: 12px;
          }
          img {
            width: 64px;
            height: 64px;
            display: inline-block;
          }
        }
      }
      .data-item-right {
        width: 100%;
        display: grid;
        grid-template-columns: 32% 32% 32%;
        gap: 16px;
        .waybill-quantity {
          border-radius: 10px;
          border: 1px solid #e9ecf2;
          grid-row-start: 1;
          grid-row-end: 3;
          padding-top: 46px;
          text-align: center;
          img {
            width: 40px;
            height: 40px;
            display: inline-block;
          }
          .waybill-quantity-content {
            font-size: 24px;
            margin-top: 10px;
            font-weight: 600;
            color: #111827;
          }
          .waybill-quantity-label {
            margin-top: 3px;
            font-size: 12px;
            font-weight: 400;
            color: #4b5563;
          }
        }
        .status-quantity {
          padding: 14px 20px;
          border-radius: 10px;
          border: 1px solid #e9ecf2;
          img {
            width: 30px;
            height: 30px;
            display: inline-block;
          }
          .status-quantity-label {
            font-size: 12px;
            font-weight: 400;
            color: #4b5563;
          }
          .status-quantity-content {
            font-size: 24px;
            font-weight: 600;
            color: #111827;
            margin-left: 8px;
          }
        }
      }
    }
  }
  .delivery-settlement {
    background: white;
    width: 100%;
    height: 330px;
    padding: 16px 20px;
    border-radius: 4px;
    margin-top: 10px;
    .stacked-line {
      display: flex;
      width: 140px;
      height: 30px;
      border-radius: 15px;
      border: 1px solid #e9ecf2;
      text-align: center;
      line-height: 26px;
      margin-top: 14px;
      font-size: 12px;
    }
    .circular-ring {
      width: 9px;
      height: 9px;
      background-color: #ffffff;
      border-radius: 50%;
      margin-top: 9px;
      margin-left: 12px;
      margin-right: 6px;
    }
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
  }
  .el-date-editor {
    .el-input__prefix {
      position: absolute;
      left: 180px; // left根据实际情况定值
      top: 0;
    }
    input {
      padding-left: 15px;
    }
  }
  // tabs样式
  .ant-radio-button-wrapper {
    background: #f6f6f8;
    border: none;
  }
  .ant-radio-button-wrapper-checked {
    background: white;
    box-shadow: 0 0 0 0 transparent !important;
  }
  .ant-radio-button-wrapper:not(:first-child)::before {
    display: none;
  }
  .el-range-editor.is-active,
  .el-range-editor.is-active:hover,
  .el-select .el-input__inner:focus,
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #59b9d3;
  }
  .el-select-dropdown__item.selected {
    color: #59b9d3 !important
  }
  .el-select-dropdown {
    z-index: 0;
    text-align: left;
  }
}
.teu-chart {
    height: 352px;
    margin-top: 10px;
    column-gap: 10px;
    display: flex;
    justify-content: space-between;
    .teu-statistics {
      flex: 1;
      padding: 16px 20px;
      background: white;
      border-radius: 4px;
      .teu-date {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 16px;
        .teu-desc {
          width: 108px;
          height: 30px;
          border-radius: 15px;
          border: 1px solid #e9ecf2;
          text-align: center;
          line-height: 26px;
          color: #58c6e4;
          div {
            &::before {
              content: "";
              display: inline-block;
              width: 5px;
              height: 5px;
              background: #58c6e4;
              border-radius: 50%;
              margin-right: 6px;
              margin-bottom: 2px;
            }
          }
        }
        .train-number-desc {
          width: 108px;
          height: 30px;
          border-radius: 15px;
          border: 1px solid #e9ecf2;
          text-align: center;
          line-height: 26px;
          color: #e66c68;
          div {
            &::before {
              content: "";
              display: inline-block;
              width: 5px;
              height: 5px;
              background: #e66c68;
              border-radius: 50%;
              margin-right: 6px;
              margin-bottom: 2px;
            }
          }
        }
      }
    }
  }

  .foot-tip {
    height: 36px;
    line-height: 36px;
    background-color: #F0F6FC;
    color: #8CA2BD;
    font-size: 12px;
    opacity: 0.85;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0px;
    padding-left: 208px;
  }
</style>
